import {createClient} from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url'

export const client = createClient({
  projectId: process.env.SANITY_PROJECT_ID,
  dataset: 'production',
  useCdn: true,
  apiVersion: '2023-05-03',
});

const builder = imageUrlBuilder(client);
export const  urlFor =(source)=>{
  return builder.image(source);
}

// Routes a Sanity CDN image URL through our own backend's /image-proxy
// endpoint instead of hitting cdn.sanity.io directly. This avoids paying for
// Sanity's asset CDN bandwidth on every page view, and - since cdn.sanity.io
// isn't in next.config.js's images.remotePatterns allowlist - is also what
// makes it possible to pass these URLs to next/image at all.
export const toProxiedUrl = (sanityUrl) => {
  if (!sanityUrl) {
    return sanityUrl;
  }
  const base = (process.env.apiHost || "").replace(/\/+$/, "");
  return `${base}/image-proxy?url=${encodeURIComponent(sanityUrl)}`;
};
export const fileBuilder = (source) => {
  try {
    if (!source?.asset?._ref) {
      return null;
    }
    const fileRef = source.asset._ref
    const [, fileId, extension] = fileRef.match(/^file-([a-zA-Z0-9]+)-(.+)$/) || [];
    if (!fileId || !extension) {
      return null;
    }
    return `https://cdn.sanity.io/files/${client.config().projectId}/${client.config().dataset}/${fileId}.${extension}`;
  } catch (error) {
    return null;
  }
};